import { createAction } from "@reduxjs/toolkit";

export interface AnalyticsEvent {
  name: string;
  params?: { [key: string]: any };
}

export const trackEvent = createAction<AnalyticsEvent>("analytics/trackEvent");
